<div class="snackbar_container"
  [ngClass]="{'bg-teal_600': snackBarState == 'general','bg-rose_600': snackBarState == 'error','bg-amber_600': snackBarState == 'caution'}">
  <p class="break-all">{{message}}</p>
</div>
